'use client'

import { logService } from '../logs'

export interface IStorageService {
  setItem(key: string, value: unknown): void
  getItem<T>(key: string): T | null
  removeItem(key: string): void
}

export const createStorageService = (): IStorageService => {
  return {
    setItem: (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value))
      } catch (err) {
        logService.error(`[StorageService] Failed to set item "${key}"`, err)
      }
    },

    getItem: <T>(key: string): T | null => {
      try {
        const item = localStorage.getItem(key)
        return item ? (JSON.parse(item) as T) : null
      } catch (err) {
        logService.error(`[StorageService] Failed to get item "${key}"`, err)
        return null
      }
    },

    removeItem: (key: string) => {
      try {
        localStorage.removeItem(key)
      } catch (err) {
        logService.error(`[StorageService] Failed to remove item "${key}"`, err)
      }
    },
  }
}
